import React from 'react';
import { benefits, images } from '../../data/content';
import { OptimizedImage } from '../OptimizedImage';
export function Benefits() {
  return <section className="bg-mist py-12 lg:py-20" aria-labelledby="benefits-title" data-id="element-227" data-mp="7fb7cbs3ekoe">
      <div className="mx-auto max-w-6xl px-5" data-id="element-228" data-mp="c95md1wr6bh5">
        <h2 id="benefits-title" className="font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-229" data-mp="g9g2h7e9ei9q">
          Dejá de empezar cada sesión <span className="text-brand-600" data-id="element-230" data-mp="3fqfgjf8kw95b">desde cero.</span>
        </h2>

        <div className="mt-5 grid items-stretch gap-6 lg:mt-8 lg:grid-cols-[280px_1fr]" data-id="element-231" data-mp="3kopajmikh3pc">
          <OptimizedImage src={images.balance} alt="Profesional acompañando a un adulto mayor en un ejercicio de equilibrio" width={1184} height={888} className="hidden h-full w-full rounded-2xl bg-brand-100 object-cover lg:block" data-id="element-232" data-mp="3oozrfu7wdeiz" />
          <ul className="grid gap-x-6 gap-y-1.5 overflow-hidden rounded-2xl bg-white p-4 ring-1 ring-brand-100 sm:grid-cols-2 lg:gap-y-2.5 lg:p-6" data-id="element-233" data-mp="13ysaw51rimaz">
            {benefits.map(b => {
            const Icon = b.icon;
            return <li key={b.label} className="flex items-center gap-2.5" data-id="element-234" data-mp="payceb57tztp">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-brand-600 text-white" data-id="element-235" data-mp="ker62h8wqmb8">
                    <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-236" data-mp="fgxxjhk4tg7s" />
                  </span>
                  <span className="font-display text-[13.5px] font-bold leading-snug text-ink lg:text-[15px]" data-id="element-237" data-mp="ai4mdvsbi1as">{b.label}</span>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}